import React from 'react'
import DataTableForCustomPaginationRoute from '../../../../components/DataTableForCustomPaginationRoute'
import {
  AGENCY_PARTNERSHIP_TYPE_ENUM,
  AGENCY_PARTNERSHIP_TYPE_MAP,
  nameSource
} from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import { toolsList } from '../domain/tools'
import Container from '../../../../components/Container'

const AgenciesList = (): JSX.Element => (
  <Container pageTitle="Listagem" breadcrumb={breadcrumbList} tools={toolsList}>
    <DataTableForCustomPaginationRoute
      paginationUrl="partnerships/agencies/pagination"
      source={nameSource}
      notHasChildren
      headers={headers}
      customHeaders={[
        {
          name: 'Tipo de parceria',
          field: 'partnership_type',
          sortable: true,
          element: item => (
            <span>
              {
                AGENCY_PARTNERSHIP_TYPE_MAP[
                  item.partnership_type as AGENCY_PARTNERSHIP_TYPE_ENUM
                ]
              }
            </span>
          )
        },
        {
          name: 'Rota',
          field: 'routes',
          sortable: true,
          element: item => <span>{item.routes?.[0]?.route?.name}</span>
        }
      ]}
    />
  </Container>
)

export default AgenciesList
